import React from "react";
import "./ViewToggle.css";

export interface ViewToggleOption<T extends string> {
  value: T;
  label: string;
  icon?: React.ReactNode;
}

interface ViewToggleProps<T extends string> {
  value: T;
  onChange: (value: T) => void;
  options: ViewToggleOption<T>[];
  /** Texto de ayuda que se muestra al lado del control. */
  hint?: string;
  className?: string;
  ariaLabel?: string;
}

/** Control segmentado (pill) para alternar entre dos o más vistas de un mismo listado. */
function ViewToggle<T extends string>({
  value,
  onChange,
  options,
  hint,
  className,
  ariaLabel,
}: ViewToggleProps<T>) {
  return (
    <div className={`vt-bar ${className ?? ""}`}>
      <div className="vt-segmented" role="group" aria-label={ariaLabel}>
        {options.map((option) => (
          <button
            key={option.value}
            type="button"
            aria-pressed={option.value === value}
            onClick={() => onChange(option.value)}
          >
            {option.icon}
            {option.label}
          </button>
        ))}
      </div>
      {hint && <span className="vt-hint">{hint}</span>}
    </div>
  );
}

export default ViewToggle;
